import { MentionType } from '../../../../../store/comments'
import { TeamEntity } from '../../../../../domain/entity/TeamEntity'

export enum MentionEntityAttributeKey {
  mentionUuid = 'data-mention-uuid',
  mentionType = 'data-mention-type',
}
export enum FileEntityAttributeKey {
  fileUrl = 'data-file-url',
  fileName = 'data-file-name',
  fileType = 'data-file-type',
}

export type UserMentionSuggestionData = {
  avatar?: string
  name: string
  uuid: string
  mentionType: typeof MentionType.USER
}
export type ProjectMentionSuggestionData = {
  uuid: string
  name: string
  mentionType: typeof MentionType.PROJECT_MEMBER
}
export type TeamMentionSuggestionData = {
  name: string
  mentionType: typeof MentionType.TEAM_MEMBER
  teams: TeamEntity[]
}
export type MentionSuggestionData =
  | UserMentionSuggestionData
  | ProjectMentionSuggestionData
  | TeamMentionSuggestionData

export type MentionReference = {
  uuid: string
  mentionType: MentionType
}
